// Stub for the nodejs builtin 'crypto' library.
export default null;

